<template>
   <div>
       <Header></Header>
       <cell></cell>
   </div>
</template>

<script>
    import Header from '../pages/header/header'
    import cell from '../pages/cell/cell'
    export default {
        name: "Exhibition",
        components:{
            cell,
            Header
        },
    }
</script>

<style scoped lang="scss">

</style>
